module.exports = __webpack_public_path__ + "img/edda8d1b829ebe3e06ddd676b49f3e68.png";